import React from 'react';
import { motion } from 'framer-motion';
import Container from '../ui/Container';
import { getThemeGroups } from '../../data/products';
import ThemeIcon from './ThemeIcon';
import './ThemeStrip.css';

/**
 * 어떤 종류의 서비스를 만들고 있고, 만들어 나갈지를 보여준다.
 * 개수는 쓰지 않는다 — 카테고리 테마로 묶어 말한다. (기획서 §6.5)
 * products.js의 theme 필드로 렌더링하므로 프로덕트가 늘어도 카피 수정이 필요 없다.
 */
const ThemeStrip = () => {
  const groups = getThemeGroups();

  return (
    <section className="ft-strip" aria-label="Flowto.AI가 만드는 서비스">
      <Container>
        <p className="ft-strip__lead">
          일상에서 쓰는 서비스를 만듭니다.
        </p>

        <ul className="ft-strip__grid">
          {groups.map((g, i) => (
            <motion.li
              key={g.key}
              className={`ft-strip__theme ft-strip__theme--${g.key}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className="ft-strip__theme-head">
                <ThemeIcon theme={g.key} />
                <span className="ft-strip__index" aria-hidden="true">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <h3 className="ft-strip__label">{g.label}</h3>
              <p className="ft-strip__desc">{g.desc}</p>

              <ul className="ft-strip__items">
                {g.items.map((p) => (
                  <li key={p.slug} className="ft-strip__item">
                    <strong>{p.nameKo}</strong>
                    <span>{p.stripLabel}</span>
                    {p.status !== 'live' && (
                      <em className="ft-strip__wip">개발 중</em>
                    )}
                  </li>
                ))}
              </ul>
            </motion.li>
          ))}
        </ul>
      </Container>
    </section>
  );
};

export default ThemeStrip;
